import React from "react";

import { CREDIT_FACILITY_LABELS } from "../../../api/credit_accounts";
import { cn } from "../../../lib/utils";
import { AccountProductInfo } from "../logic/slice";

export interface LoanAccountPopoverRowProps {
  account: AccountProductInfo;
  showDivider?: boolean;
}

const LoanAccountPopoverRow: React.FC<LoanAccountPopoverRowProps> = ({ account, showDivider }) => {
  const accountLabel = `${account.account_name || "-"} (${account.ext_account_number})`;
  const facilityLabel = `${account.product || "-"} • ${
    account.credit_facility ? CREDIT_FACILITY_LABELS[account.credit_facility] : "-"
  }`;

  return (
    <div className={cn("flex flex-col gap-1 px-2 py-[6px]", showDivider && "border-t border-[#E5E5E5]")}>
      <span className="truncate text-sm text-[#0A0A0A]" title={accountLabel}>
        {accountLabel}
      </span>

      <span className="truncate text-xs text-[#737373]" title={facilityLabel}>
        {facilityLabel}
      </span>
    </div>
  );
};

export default LoanAccountPopoverRow;
